import React, { useEffect } from 'react';
import { Button, Typography } from 'antd';
import { CheckCircleFilled } from '@ant-design/icons';

const { Title, Text } = Typography;

function RatingSuccessPage(props) {
	const params = new URLSearchParams(props.location.search);
	const caterer = params.get('caterer') || 'the caterer';

	useEffect(() => {
		window.scrollTo({ top: 0, behavior: 'smooth' });
	}, []);

	return (
		<div
			style={{
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				justifyContent: 'center',
				minHeight: '70vh',
				padding: '32px 16px'
			}}
		>
			<div
				style={{
					backgroundColor: '#ffffff',
					borderRadius: 8,
					boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
					padding: '56px 48px',
					textAlign: 'center',
					maxWidth: 520,
					width: '100%'
				}}
			>
				<CheckCircleFilled style={{ fontSize: 72, color: '#52c41a', marginBottom: 24 }} />
				<Title level={2} style={{ color: '#003366', marginBottom: 12 }}>
					Thank You!
				</Title>
				<Text
					style={{ fontSize: 17, color: '#595959', display: 'block', marginBottom: 32, lineHeight: 1.6 }}
				>
					Your rating for <strong>{caterer}</strong> has been submitted.
				</Text>
				{/* <Button
					type="primary"
					size="large"
					onClick={() => props.history.push('/rating')}
					style={{
						backgroundColor: '#003366',
						borderColor: '#003366',
						minWidth: 160,
						fontWeight: 600
					}}
				>
					Rate Another Caterer
				</Button> */}
			</div>
		</div>
	);
}

export default RatingSuccessPage;
